<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import Icon from 'smelte/src/components/Icon/Icon.svelte'
  import CheckboxGroup from '../ConditionMonitoring/CheckboxGroup.svelte'
  import { slide } from 'svelte/transition'

  export let fk = ''
  export let label = ''
  export let data = []

  export let bg = 'bg-gray-200'
  export let add = ''
  export let remove = ''
  export let group = []

  let items = []
  let _group = []
  let showList = false

  const dispatch = createEventDispatcher()

  const optionsClassesDefault = 'text-gray-700 bg-white rounded elevation-2 w-full mt-1' +
    ' overflow-y-auto text-base cursor-pointer'
  const classesDefault = 'cursor-pointer relative'

  $: optionsClasses = optionsClassesDefault.split(' ').filter(p => !remove.split(' ').includes(p)).join(' ') + ' ' + add

  $: onSelectionChanged(group)

  const unwind = (acc, v) => {
    acc.push(...v.split(';'))
    return acc
  }

  const uniqueOnly = (v, i, a) => v !== '' && a.indexOf(v.trim()) === i

  onMount(() => {
    // console.log('[DEBUG] data ', fk, data.slice(0,10))
    items = data
      .filter(p => p[fk] != null)
      .map(p => p[fk].trim())
      .reduce(unwind, [])
      .filter(uniqueOnly)
      .sort((a, b) => a < b ? -1 : 1)
  })

  function onSelectionChanged (group) {
    if (group.length != _group.length) {
      dispatch('change', group)
      _group = [...group]
    }
  }
</script>

<div class="cursor-pointer flex text-gray-700" on:click={() => { showList = !showList }}>
  <div class="font-medium flex-grow">
    {label}
  </div>
  <div>
    <Icon>{showList ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
  </div>
</div>


{#if !showList}
<div class="flex flex-wrap mb-5 text-white">
  {#each group as g}
    <div class="mb-1 mr-1 rounded-full px-3 py-1 bg-red-400">
      <span>{g}</span>
      <Icon class="cursor-pointer text-sm" on:click={() => { group = group.filter(p => p !== g) }}>
        close
      </Icon>
    </div>
  {/each}
</div>
{:else}
  <div class={classesDefault}>
    <div transition:slide class={optionsClasses} style="max-height: 20rem">
      <CheckboxGroup add="filter-cb"
                     items={items.map(p => ({value: p, label: p}))}
                     bind:group={group} />
    </div>
  </div>
{/if}

<style>
    :global(.filter-cb span) {
        padding: 0;
    }

    /*
    :global(.filter-cb i) {
        color: #bbb !important;
    }
    */
</style>
